import { useState, useEffect, useRef } from "react";
import { findBoundsOfArrayOfItems } from "../../../refractCommon/miro/findBoundsOfArrayOfItems";

const { board } = window.miro;

function FlipGroup({ boardSelection }) {
  const [filteredSelection, setFilteredSelection] = useState([]);
  const [helpText, setHelpText] = useState("");
  const [toolOpen, setToolOpen] = useState(false);
  const [setHeight, setHeightState] = useState("0px");

  const content = useRef(null);

  function handleToggleOpen() {
    setToolOpen(!toolOpen);
    setHeightState(toolOpen ? "0px" : `${content.current.scrollHeight}px`);
  }
  useEffect(async () => {
    let filteredBoardSelection = await runSetFilteredSelection(boardSelection);
    setFilteredSelection(filteredBoardSelection);
  }, []);

  useEffect(async () => {
    let filteredBoardSelection = await runSetFilteredSelection(boardSelection);
    setFilteredSelection(filteredBoardSelection);
  }, [boardSelection]);

  // lets get board selection just in time and filter it with this
  async function runSetFilteredSelection(selection) {
    let filteredSelection = runFilterSelectionForFlipGroup(selection);
    return filteredSelection;
  }

  // SCALE TOOL APPLICABLE ITEM TYPES
  function runFilterSelectionForFlipGroup(selection) {
    let filteredSelection = selection.filter(
      (item) =>
        (item.type === "sticky_note" && item.parentId === null) ||
        (item.type === "text" && item.parentId === null) ||
        (item.type === "card" && item.parentId === null) ||
        (item.type === "shape" && item.parentId === null) ||
        (item.type === "frame" && item.childrenIds.length === 0) ||
        (item.type == "image" && item.parentId === null)
    );

    // setBoardSelection(filteredSelection);
    return filteredSelection;
  }
  // ROTATE NORMAL TOOL APPLICABLE ITEM TYPE ICONS TO MATCH
  const flipGroupTypeIcons = (
    <div className="cs5 ce12 grid">
      <div className="m2 icon icon-rectangle cs1"></div>
      <div className="m2 icon icon-sticky cs2"></div>
      <div className="m2 icon icon-card cs3"></div>
      <div className="m2 icon icon-text cs4"></div>
      <div className="m2 icon icon-image cs5"></div>
      <div className="m2 icon icon-frame cs6"></div>
    </div>
  );

  async function runFlipHorizontal(flag) {
    let selection = await board.getSelection();
    let filteredSelection = runFilterSelectionForFlipGroup(selection);
    let { centroidX: centerX } = findBoundsOfArrayOfItems(filteredSelection);

    for (const item of filteredSelection) {
      let distFromCenterX = item.x - centerX;
      let newX = item.x - 2 * distFromCenterX;
      item.x = newX;
      if (flag === "rotateAlso") {
        if (["shape", "image", "card", "text"].includes(item.type)) {
          item.rotation = -item.rotation;
        }
      }
      await item.sync();
    }
  }

  async function runFlipVertical(flag) {
    let selection = await board.getSelection();
    let filteredSelection = runFilterSelectionForFlipGroup(selection);
    let { centroidY: centerY } = findBoundsOfArrayOfItems(filteredSelection);

    for (const item of filteredSelection) {
      let distFromCenterY = item.y - centerY;
      let newY = item.y - 2 * distFromCenterY;
      item.y = newY;

      if (flag === "rotateAlso") {
        if (["shape", "image", "card", "text"].includes(item.type)) {
          item.rotation = -item.rotation - 180;
        }
      }
      await item.sync();
    }
  }

  return (
    <div id="flip-group-tool" className="grid tool-section mt-0 pb-0">
      <div
        id="flip-group-tool-header"
        className={"grid cs1 ce12 mt-0 cursor-pointer"}
        onClick={(event) => {
          handleToggleOpen();
        }}>
        <div className="icon m2 icon-drag cs1"></div>
        <h3 className="h3 cs2 ce11 mt-0 pb-0 mb-0">Flip a group</h3>
        <div
          className={
            "cs12 icon m2 mb-0 mt-0 cursor-pointer" +
            " " +
            (toolOpen === false ? "icon-arrow-right" : "icon-arrow-down")
          }></div>
      </div>
      <div
        id="accordion-content"
        ref={content}
        style={{ maxHeight: `${setHeight}` }}
        className="cs1 ce12 grid accordion">
        <div id="accordion-margin" className="cs1 ce12 grid mb-8">
          <p className="p-medium mt-0 pt-0 cs1 ce12 mb-0">
            Flip a group of items around its center lines; vertically or
            horizontally. Items remain properly-oriented.
          </p>
          {/* HELP BOX */}
          <div
            id="circle-works-on"
            className="help-container grid cs1 ce12 mt-0 mb-8 pt-8">
            <p className="p-small cs1 ce4 mb-0 mt-0">
              Works on
              <b> many:</b>
            </p>
            {flipGroupTypeIcons}
            {filteredSelection.length === 0 ? (
              <p
                className="p-medium cs1 ce12 align-center mb-0 mt-0 "
                style={{
                  color: "var(--red900)",
                }}>
                Select <b>at least one item</b> of the above types.
              </p>
            ) : (
              <p className="p-medium cs1 ce12 align-center mb-0 mt-0 ">
                <b>{filteredSelection.length} flip-able</b> items selected.
              </p>
            )}
          </div>
          {/*  */}

          {/* <div className="p-large cs1 ce12">Title</div> */}

          <button
            type="button"
            className="button button-primary button-small cs1 ce6 mb-0 mt-0 mr-0 "
            onClick={() => runFlipHorizontal("")}>
            Horizontal
          </button>

          <button
            type="button"
            className="button button-primary button-small cs7 ce12 mb-0 mt-0 mr-0 "
            onClick={() => runFlipVertical("")}>
            Vertical
          </button>
          <button
            type="button"
            className="button button-secondary fix-button-secondary button-small cs1 ce6 mb-0 mt-0 mr-0 "
            onClick={() => runFlipHorizontal("rotateAlso")}>
            Horiz: Mirror-ish
          </button>

          <button
            type="button"
            className="button button-secondar fix-button-secondary button-small cs7 ce12 mb-0 mt-0 mr-0 "
            onClick={() => runFlipVertical("rotateAlso")}>
            Vert: Mirror-ish
          </button>
        </div>
      </div>
    </div>
  );
}

export default FlipGroup;
